"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionEffectType = exports.AutomationButtonVariant = exports.AutomationButtonAction = exports.TimeFormatValue = void 0;
var TimeFormatValue;
(function (TimeFormatValue) {
    TimeFormatValue["Time"] = "h:mm a";
    TimeFormatValue["Day"] = "dddd";
    TimeFormatValue["DayAndTime"] = "dddd [at] h:mma z";
    TimeFormatValue["DayAndDate"] = "dddd[,] MMMM Do";
    TimeFormatValue["DayAndDateAndYear"] = "dddd[,] MMMM Do[,] YYYY";
    TimeFormatValue["DayAndDateAndTime"] = "dddd[,] MMMM Do [at] h:mma z";
    TimeFormatValue["DayAndDateAndTimeAndYear"] = "dddd[,] MMMM Do[,] YYYY [at] h:mma z";
})(TimeFormatValue = exports.TimeFormatValue || (exports.TimeFormatValue = {}));
var AutomationButtonAction;
(function (AutomationButtonAction) {
    AutomationButtonAction["AddConversationTags"] = "addConversationTags";
    AutomationButtonAction["PinConversation"] = "pinConversation";
    AutomationButtonAction["ScheduleWorkflow"] = "scheduleWorkflow";
    AutomationButtonAction["SetAppointmentStatus"] = "setAppointmentStatus";
    AutomationButtonAction["SetConversationStatus"] = "setConversationStatus";
    AutomationButtonAction["CreateTask"] = "createTask";
})(AutomationButtonAction = exports.AutomationButtonAction || (exports.AutomationButtonAction = {}));
var AutomationButtonVariant;
(function (AutomationButtonVariant) {
    AutomationButtonVariant["GhostNeutral"] = "ghostNeutral";
    AutomationButtonVariant["Primary"] = "primary";
    AutomationButtonVariant["Secondary"] = "secondary";
})(AutomationButtonVariant = exports.AutomationButtonVariant || (exports.AutomationButtonVariant = {}));
var ActionEffectType;
(function (ActionEffectType) {
    ActionEffectType["None"] = "None";
    ActionEffectType["ConfirmAppointment"] = "Confirm Appointment";
    ActionEffectType["AddAppointmentNote"] = "Add Appointment Note";
    ActionEffectType["AddTagsToChannel"] = "Tag Conversation";
    ActionEffectType["ScheduleWorkflow"] = "Schedule Workflow";
    ActionEffectType["CreateTask"] = "Create Task";
})(ActionEffectType = exports.ActionEffectType || (exports.ActionEffectType = {}));
//# sourceMappingURL=WorkflowEventActionConfig.js.map